<template>
    <div>
        <vs-alert color="primary" class="headers-item">
            <div class="flex justify-between items-center">
                <div class="flex items-center">
                    <b>{{ name }}</b>
                    <div class="ml-2 text-xs">{{ type }}</div>
                </div>
                <vs-chip v-if="required" color="warning" transparent>Required*</vs-chip>
            </div>
            <div>{{ description }}</div>
            <div v-if="format"><span style="color: green">Format: </span><span class="ml-2">{{format}}</span></div>
        </vs-alert>
        <div v-if="children" v-for="(value, index) of children" :key="index">
            <div v-for="(v, n) in value" class="pl-10 headers-item">
                <param-element
                    :description="v.description"
                    :name="n"
                    :type="v.type"
                    :required="v.required"
                    :children="v.children"
                    :format="v.format"
                ></param-element>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'param-element',
    props: {
        type: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        description: {
            type: String|undefined,
            required: true
        },
        format: {
            type: String
        },
        required: {
            type: Boolean
        },
        children: {
            type: Array
        }
    }
}
</script>

<style lang="scss">
.headers {
    &-item {
        margin-bottom: 1rem;
        &:last-child {
            margin-bottom: 0;
        }
    }
}

</style>
